import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
	fetchPaymentHistory, updatePaymentHistory,
	markAsPaid, addInstalment, markAsCancelled, cancelLesson, sendInvoice, refundUnbookedAnnual, applyPromoCode, retryInstalment,
	PAYMENT_HISTORY_MARK_AS_PAID_REQUEST, PAYMENT_HISTORY_MARK_AS_PAID_SUCCESS, PAYMENT_HISTORY_MARK_AS_PAID_FAILURE,
	PAYMENT_HISTORY_ADD_INSTALMENT_REQUEST, PAYMENT_HISTORY_ADD_INSTALMENT_SUCCESS, PAYMENT_HISTORY_ADD_INSTALMENT_FAILURE,
	PAYMENT_HISTORY_MARK_AS_CANCELLED_REQUEST, PAYMENT_HISTORY_MARK_AS_CANCELLED_SUCCESS, PAYMENT_HISTORY_MARK_AS_CANCELLED_FAILURE,
	PAYMENT_HISTORY_REFUND_UNBOOKED_ANNUAL_REQUEST, PAYMENT_HISTORY_REFUND_UNBOOKED_ANNUAL_SUCCESS, PAYMENT_HISTORY_REFUND_UNBOOKED_ANNUAL_FAILURE,
	PAYMENT_HISTORY_ADD_PROMO_CODE_REQUEST, PAYMENT_HISTORY_ADD_PROMO_CODE_SUCCESS, PAYMENT_HISTORY_ADD_PROMO_CODE_FAILURE,
	PAYMENT_HISTORY_RETRY_INSTALMENT_REQUEST, PAYMENT_HISTORY_RETRY_INSTALMENT_SUCCESS, PAYMENT_HISTORY_RETRY_INSTALMENT_FAILURE,
	requestSubscriptionCancellation, withdrawSubscriptionCancellation,
	SUBSCRIPTION_CANCELLATION_REQUEST_REQUEST, SUBSCRIPTION_CANCELLATION_REQUEST_SUCCESS, SUBSCRIPTION_CANCELLATION_REQUEST_FAILURE
} from './actions';
import {
	markAsPaidInstalment,
	INSTALMENT_PAYMENT_MARK_AS_PAID_REQUEST, INSTALMENT_PAYMENT_MARK_AS_PAID_SUCCESS, INSTALMENT_PAYMENT_MARK_AS_PAID_FAILURE
} from '../instalmentPayments/actions';
import MarkAsPaidInstalmentDialog from './MarkAsPaidInstalmentDialog';
import { generateChildLessons, GENERATE_CHILD_LESSONS_REQUEST, GENERATE_CHILD_LESSONS_SUCCESS, GENERATE_CHILD_LESSONS_FAILURE } from '../attendance/actions';
import PaymentHistorySettingsForm from './SettingsForm';
import { selector as promoCodeFormSelector } from './PromoCodeForm';
import MarkAsPaidDialog from './MarkAsPaidDialog';
import AddInstalmentDialog from './AddInstalmentDialog';
import MarkAsNotApprovedDialog from './MarkAsNotApprovedDialog';
import MarkAsCancelledDialog from './MarkAsCancelledDialog';
import { isSubscriptionRunning } from './SubscriptionPanel';
import RefundUnbookedAnnualDialog from '../paymentHistory/RefundUnbookedAnnualDialog';
import PromoCodeDialog from './PromoCodeDialog';
import RecordSubscriptionCancellationDialog from './RecordSubscriptionCancellationDialog';
import authUtils from '../../auth/utils';
import { withTranslation } from 'react-i18next';

class Details extends Component {
	constructor(props) {
		super(props);
		this.handlePaymentHistorySettingsSubmit = this.handlePaymentHistorySettingsSubmit.bind(this);
		this.handleMarkAsCancelledDialogConfirm = this.handleMarkAsCancelledDialogConfirm.bind(this);
		this.showMarkAsCancelledDialog = this.showMarkAsCancelledDialog.bind(this);
		this.hideMarkAsCancelledDialog = this.hideMarkAsCancelledDialog.bind(this);
		this.handleMarkAsPaidDialogConfirm = this.handleMarkAsPaidDialogConfirm.bind(this);
		this.showMarkAsPaidDialog = this.showMarkAsPaidDialog.bind(this);
		this.hideMarkAsPaidDialog = this.hideMarkAsPaidDialog.bind(this);
		this.showMarkAsPaidInstalmentDialog = this.showMarkAsPaidInstalmentDialog.bind(this);
		this.hideMarkAsPaidInstalmentDialog = this.hideMarkAsPaidInstalmentDialog.bind(this);
		this.handleMarkAsPaidInstalmentDialogConfirm = this.handleMarkAsPaidInstalmentDialogConfirm.bind(this);
		this.handleAddInstalmentDialogConfirm = this.handleAddInstalmentDialogConfirm.bind(this);
		this.showAddInstalmentDialog = this.showAddInstalmentDialog.bind(this);
		this.hideAddInstalmentDialog = this.hideAddInstalmentDialog.bind(this);
		this.handleMarkAsNotApprovedDialogConfirm = this.handleMarkAsNotApprovedDialogConfirm.bind(this);
		this.showMarkAsNotApprovedDialog = this.showMarkAsNotApprovedDialog.bind(this);
		this.hideMarkAsNotApprovedDialog = this.hideMarkAsNotApprovedDialog.bind(this);
		this.handleCancelLesson = this.handleCancelLesson.bind(this);
		this.reloadPaymentHistory = this.reloadPaymentHistory.bind(this);
		this.handleSendInvoice = this.handleSendInvoice.bind(this);
		this.handleRefundUnbookedAnnualDialogConfirm = this.handleRefundUnbookedAnnualDialogConfirm.bind(this);
		this.showRefundUnbookedAnnualDialog = this.showRefundUnbookedAnnualDialog.bind(this);
		this.hideRefundUnbookedAnnualDialog = this.hideRefundUnbookedAnnualDialog.bind(this);
		this.showPromoCodeDialog = this.showPromoCodeDialog.bind(this);
		this.showRecordSubscriptionCancellationDialog = this.showRecordSubscriptionCancellationDialog.bind(this);
		this.hideRecordSubscriptionCancellationDialog = this.hideRecordSubscriptionCancellationDialog.bind(this);
		this.handleRecordSubscriptionCancellationConfirm = this.handleRecordSubscriptionCancellationConfirm.bind(this);
		this.handleWithdrawSubscriptionCancellation = this.handleWithdrawSubscriptionCancellation.bind(this);
		this.hidePromoCodeDialog = this.hidePromoCodeDialog.bind(this);
		this.handlePromoCodeApply = this.handlePromoCodeApply.bind(this);
		this.handleRetryInstalment = this.handleRetryInstalment.bind(this);
		this.state = {
			showMarkAsCancelledDialog: false,
			showMarkAsPaidDialog: false,
			showMarkAsPaidInstalmentDialog: false,
			showAddInstalmentDialog: false,
			showMarkAsNotApprovedDialog: false,
			showRefundUnbookedAnnualDialog: false,
			showPromoCodeDialog: false,
			showRecordSubscriptionCancellationDialog: false
		};
	}

	componentDidMount() {
		this.reloadPaymentHistory();
	}

	handlePaymentHistorySettingsSubmit(values) {
		const { paymentHistory, updatePaymentHistory, history } = this.props;

		if (paymentHistory) {
			updatePaymentHistory(paymentHistory.id, values);
		}
	}

	reloadPaymentHistory() {
		const { match, fetchPaymentHistory } = this.props;
		const paymentHistoryId = match.params.id;

		if (paymentHistoryId) {
			fetchPaymentHistory(paymentHistoryId);
		}
	}

	handleCancelLesson(lessonId) {
		const { cancelLesson } = this.props;
		const onSuccessEvent = () => this.reloadPaymentHistory();
		cancelLesson(lessonId, onSuccessEvent);
	}

	handleSendInvoice() {
		const { paymentHistory, sendInvoice } = this.props;
		if (paymentHistory) {
			sendInvoice(paymentHistory.id);
		}
	}

	handleMarkAsCancelledDialogConfirm(values) {
		const { paymentHistory, markAsCancelled } = this.props;
		if (paymentHistory) {
			markAsCancelled(paymentHistory.id, values, () => {
				this.hideMarkAsCancelledDialog();
				this.reloadPaymentHistory();
			});
		}
	}

	showMarkAsCancelledDialog() {
		this.setState({
			showMarkAsCancelledDialog: true
		});
	}

	hideMarkAsCancelledDialog() {
		this.setState({
			showMarkAsCancelledDialog: false
		});
	}

	showRecordSubscriptionCancellationDialog() {
		this.setState({
			showRecordSubscriptionCancellationDialog: true
		});
	}

	hideRecordSubscriptionCancellationDialog() {
		this.setState({
			showRecordSubscriptionCancellationDialog: false
		});
	}

	handleRecordSubscriptionCancellationConfirm(values) {
		const { paymentHistory, requestSubscriptionCancellation } = this.props;
		if (paymentHistory) {
			requestSubscriptionCancellation(paymentHistory.id, values, () => {
				this.hideRecordSubscriptionCancellationDialog();
				this.reloadPaymentHistory();
			});
		}
	}

	handleWithdrawSubscriptionCancellation() {
		const { paymentHistory, withdrawSubscriptionCancellation } = this.props;
		if (paymentHistory) {
			withdrawSubscriptionCancellation(paymentHistory.id, this.reloadPaymentHistory);
		}
	}

	handleRefundUnbookedAnnualDialogConfirm(values) {
		const { paymentHistory, refundUnbookedAnnual } = this.props;
		if (paymentHistory) {
			refundUnbookedAnnual(paymentHistory.id, values, this.hideRefundUnbookedAnnualDialog);
		}
	}

	showRefundUnbookedAnnualDialog() {
		this.setState({
			showRefundUnbookedAnnualDialog: true
		});
	}

	hideRefundUnbookedAnnualDialog() {
		this.setState({
			showRefundUnbookedAnnualDialog: false
		});
	}

	handleMarkAsPaidDialogConfirm(values) {
		const { paymentHistory, markAsPaid } = this.props;
		if (paymentHistory) {
			markAsPaid(paymentHistory.id, values,
				() => {
					this.hideMarkAsPaidDialog();
					this.reloadPaymentHistory();
				});
		}
	}

	showMarkAsPaidDialog() {
		this.setState({
			showMarkAsPaidDialog: true
		});
	}

	hideMarkAsPaidDialog() {
		this.setState({
			showMarkAsPaidDialog: false
		});
	}

	handleMarkAsPaidInstalmentDialogConfirm(values) {
		const { markAsPaidInstalment } = this.props;
		var instalment = this.state.instalment;
		if (instalment) {
			markAsPaidInstalment(instalment.id, values,
				() => {
					this.hideMarkAsPaidInstalmentDialog();
					this.reloadPaymentHistory();
				});
		}
	}

	showMarkAsPaidInstalmentDialog(instalment) {
		this.setState({
			showMarkAsPaidInstalmentDialog: true,
			instalment
		});
	}

	hideMarkAsPaidInstalmentDialog() {
		this.setState({
			showMarkAsPaidInstalmentDialog: false
		});
	}


	handleAddInstalmentDialogConfirm(values) {
		const { paymentHistory, addInstalment } = this.props;
		if (paymentHistory) {
			addInstalment(paymentHistory.id, values, () => {
				this.hideAddInstalmentDialog();
				this.reloadPaymentHistory();
			});			
		}
	}

	showAddInstalmentDialog() {
		this.setState({
			showAddInstalmentDialog: true
		});
	}

	hideAddInstalmentDialog() {
		this.setState({
			showAddInstalmentDialog: false
		});
	}

	handleMarkAsNotApprovedDialogConfirm(values) {
		const { paymentHistory, generateChildLessons } = this.props;

		if (paymentHistory) {
			const onSuccessEvent = () => {
				this.hideMarkAsNotApprovedDialog();
				this.reloadPaymentHistory();
			};
			generateChildLessons({ paymentId: paymentHistory.id, notes: values.notes }, onSuccessEvent);
		}
	}

	showMarkAsNotApprovedDialog() {
		this.setState({
			showMarkAsNotApprovedDialog: true
		});
	}

	hideMarkAsNotApprovedDialog() {
		this.setState({
			showMarkAsNotApprovedDialog: false
		});
	}

	showPromoCodeDialog() {
		this.setState({
			showPromoCodeDialog: true
		});
	}

	hidePromoCodeDialog() {
		this.setState({
			showPromoCodeDialog: false
		});
	}

	handlePromoCodeApply(values) {
		const { paymentHistory, applyPromoCode } = this.props;
		if (paymentHistory) {
			applyPromoCode(paymentHistory.id, values.promoCode, () => {
				this.hidePromoCodeDialog();
				this.reloadPaymentHistory();
			});
		}
	}

	handleRetryInstalment(instalmentPaymentId) {
		const { paymentHistory, retryInstalment } = this.props;
		if (paymentHistory) {
			retryInstalment(paymentHistory.id, instalmentPaymentId, this.reloadPaymentHistory);
		}
	}

	render() {
		const { paymentHistory, canMarkAsPaid, canCancel, canCancelLesson, isReadonly, canMarkAsNotApproved, canUploadInvoice, canSendInvoice,
			canRefundUnbookedAnnual, cancellationReasonTypes, canApplyPromoCode, newPromoCode, showPaymentOptions,
			enableManualInstalment, canAddInstalment, isManualInstalment, canRetryInstalment, cancellationRequestChannels, canManageSubscription, canViewSentEmails } = this.props;

		if (paymentHistory) {
			return (
				<div>
					<MarkAsPaidDialog show={this.state.showMarkAsPaidDialog}
						showPaymentOptions={showPaymentOptions}
						enableManualInstalment={enableManualInstalment}
						block={PAYMENT_HISTORY_MARK_AS_PAID_REQUEST}
						unblock={[PAYMENT_HISTORY_MARK_AS_PAID_SUCCESS, PAYMENT_HISTORY_MARK_AS_PAID_FAILURE]}
						onConfirm={this.handleMarkAsPaidDialogConfirm}
						onCancel={this.hideMarkAsPaidDialog} />
					<AddInstalmentDialog show={this.state.showAddInstalmentDialog}
						block={PAYMENT_HISTORY_ADD_INSTALMENT_REQUEST}
						unblock={[PAYMENT_HISTORY_ADD_INSTALMENT_SUCCESS, PAYMENT_HISTORY_ADD_INSTALMENT_FAILURE]}
						onConfirm={this.handleAddInstalmentDialogConfirm}
						onCancel={this.hideAddInstalmentDialog} />
					<MarkAsNotApprovedDialog show={this.state.showMarkAsNotApprovedDialog}
						block={GENERATE_CHILD_LESSONS_REQUEST}
						unblock={[GENERATE_CHILD_LESSONS_SUCCESS, GENERATE_CHILD_LESSONS_FAILURE]}
						onConfirm={this.handleMarkAsNotApprovedDialogConfirm}
						onCancel={this.hideMarkAsNotApprovedDialog} />
					<MarkAsCancelledDialog show={this.state.showMarkAsCancelledDialog}
						block={PAYMENT_HISTORY_MARK_AS_CANCELLED_REQUEST}
						unblock={[PAYMENT_HISTORY_MARK_AS_CANCELLED_SUCCESS, PAYMENT_HISTORY_MARK_AS_CANCELLED_FAILURE]}
						onConfirm={this.handleMarkAsCancelledDialogConfirm}
						onCancel={this.hideMarkAsCancelledDialog}
						isManualInstalment={isManualInstalment}
						outstandingTotal={paymentHistory.outstandingTotal}
						paymentMethod={paymentHistory.paymentMethod && paymentHistory.paymentMethod.name}
						showWarning={paymentHistory.isInstalmentPayment && (paymentHistory.status.id === 2 || paymentHistory.status.id === 6) }
						subscription={isSubscriptionRunning(paymentHistory.subscription) ? paymentHistory.subscription : null}
						removesFrom={paymentHistory.isInstalmentPayment && paymentHistory.status.id === 2 ? 'lessons' : null}
					/>
					{paymentHistory.subscription && <RecordSubscriptionCancellationDialog show={this.state.showRecordSubscriptionCancellationDialog}
						paymentId={paymentHistory.id}
						cancellationRequestChannels={cancellationRequestChannels}
						block={SUBSCRIPTION_CANCELLATION_REQUEST_REQUEST}
						unblock={[SUBSCRIPTION_CANCELLATION_REQUEST_SUCCESS, SUBSCRIPTION_CANCELLATION_REQUEST_FAILURE]}
						onConfirm={this.handleRecordSubscriptionCancellationConfirm}
						onCancel={this.hideRecordSubscriptionCancellationDialog} />}
					<RefundUnbookedAnnualDialog show={this.state.showRefundUnbookedAnnualDialog}
						cancellationReasonTypes={cancellationReasonTypes}
						block={PAYMENT_HISTORY_REFUND_UNBOOKED_ANNUAL_REQUEST}
						unblock={[PAYMENT_HISTORY_REFUND_UNBOOKED_ANNUAL_SUCCESS, PAYMENT_HISTORY_REFUND_UNBOOKED_ANNUAL_FAILURE]}
						onConfirm={this.handleRefundUnbookedAnnualDialogConfirm}
						onCancel={this.hideRefundUnbookedAnnualDialog} />
					<PromoCodeDialog show={this.state.showPromoCodeDialog}
						block={PAYMENT_HISTORY_ADD_PROMO_CODE_REQUEST}
						unblock={[PAYMENT_HISTORY_ADD_PROMO_CODE_SUCCESS, PAYMENT_HISTORY_ADD_PROMO_CODE_FAILURE]}
						onConfirm={this.handlePromoCodeApply}
						onCancel={this.hidePromoCodeDialog}
						newPromoCode={newPromoCode} />
					<MarkAsPaidInstalmentDialog show={this.state.showMarkAsPaidInstalmentDialog}						
						block={INSTALMENT_PAYMENT_MARK_AS_PAID_REQUEST}
						unblock={[INSTALMENT_PAYMENT_MARK_AS_PAID_SUCCESS, INSTALMENT_PAYMENT_MARK_AS_PAID_FAILURE]}
						onConfirm={this.handleMarkAsPaidInstalmentDialogConfirm}
						onCancel={this.hideMarkAsPaidInstalmentDialog} />
					<PaymentHistorySettingsForm
						isReadonly={isReadonly}
						onSubmit={this.handlePaymentHistorySettingsSubmit}
						initialValues={paymentHistory}
						payment={paymentHistory}
						lessons={paymentHistory.allLessons}
						canMarkAsPaid={canMarkAsPaid}
						canCancel={canCancel}
						canCancelLesson={canCancelLesson}
						canMarkAsNotApproved={canMarkAsNotApproved}
						markAsPaid={this.showMarkAsPaidDialog}
						markAsCancelled={this.showMarkAsCancelledDialog}
						markAsNotApproved={this.showMarkAsNotApprovedDialog}
						cancelLesson={this.handleCancelLesson}
						canUploadInvoice={canUploadInvoice}
						canSendInvoice={canSendInvoice}
						sendInvoice={this.handleSendInvoice}
						canRefundUnbookedAnnual={canRefundUnbookedAnnual}
						refundUnbookedAnnual={this.showRefundUnbookedAnnualDialog}
						canApplyPromoCode={canApplyPromoCode}
						onApplyPromoCode={this.showPromoCodeDialog}
						canAddInstalment={canAddInstalment}
						addInstalment={this.showAddInstalmentDialog}
						canRetryInstalment={canRetryInstalment}
						retryInstalment={this.handleRetryInstalment}
						markInstalmentAsPaid={this.showMarkAsPaidInstalmentDialog}
						canMarkInstalmentAsPaid={this.props.canMarkInstalmentAsPaid}
						onRefresh={this.reloadPaymentHistory}
						canManageSubscription={canManageSubscription}
						canViewSentEmails={canViewSentEmails}
						recordSubscriptionCancellation={this.showRecordSubscriptionCancellationDialog}
						withdrawSubscriptionCancellation={this.handleWithdrawSubscriptionCancellation}
					/>
				</div>
			);
		}
		return null;
	}
}

const mapStateToProps = (state, ownProps) => {
	const paymentHistoryId = ownProps.match.params.id;
	
	const {
		entities: { paymentHistories },
		configuration: { franchisor },
		lookups: { cancellationReasonTypes, cancellationRequestChannels },
		auth: { currentUser }
	} = state;

	const paymentHistory = paymentHistories[paymentHistoryId];
	let canMarkAsPaid, canAddInstalment, canCancel, canCancelLesson, canMarkAsNotApproved, canUploadInvoice, canSendInvoice, canRefundUnbookedAnnual,
		canApplyPromoCode, showPaymentOptions, isManualInstalment;
	if (paymentHistory) {
		canMarkAsPaid = paymentHistory.canMarkAsPaid && authUtils.hasPermission(currentUser, 'MarkAsPaid');
		canAddInstalment = paymentHistory.canAddInstalment && authUtils.hasPermission(currentUser, 'MarkAsPaid');
		canCancel = paymentHistory.canCancel && authUtils.hasPermission(currentUser, 'MarkAsPaid');
		canCancelLesson = authUtils.hasPermission(currentUser, 'CancelChildLesson');
		canMarkAsNotApproved = paymentHistory.canMarkAsNotApproved && authUtils.hasPermission(currentUser, 'MarkAsPaid') && authUtils.hasPermission(currentUser, 'ChildLessons');
		canUploadInvoice = authUtils.hasPermission(currentUser, 'UploadInvoice');
		canSendInvoice = authUtils.hasPermission(currentUser, 'MarkAsPaid') && paymentHistory.status.id === 2 && paymentHistory.total > 0 && !paymentHistory.paymentParentId;
		canRefundUnbookedAnnual = paymentHistory.canRefundUnbookedAnnual && authUtils.hasPermission(currentUser, 'MarkAsPaid');
		canApplyPromoCode = paymentHistory.canApplyPromoCode && authUtils.hasPermission(currentUser, 'MarkAsPaid');
		showPaymentOptions = paymentHistory.showPaymentOptions;
		isManualInstalment = paymentHistory.isManualInstalment;
	}

	return {
		paymentHistory: paymentHistory,
		paymentHistoryId: paymentHistoryId,
		canMarkAsPaid,
		canCancel,
		canCancelLesson,
		canMarkAsNotApproved,
		canUploadInvoice,
		canSendInvoice,
		canRefundUnbookedAnnual,
		cancellationReasonTypes,
		cancellationRequestChannels,
		canManageSubscription: authUtils.hasPermission(currentUser, 'MarkAsPaid') && !authUtils.hasReadOnlyPermission(currentUser, 'PaymentHistory'),
		canViewSentEmails: authUtils.hasPermission(currentUser, 'SentEmails'),
		canApplyPromoCode,
		canRetryInstalment: authUtils.hasPermission(currentUser, 'MarkAsPaid'),
		canMarkInstalmentAsPaid: authUtils.hasPermission(currentUser, 'MarkInstalmentAsPaid'),
		showPaymentOptions,
		newPromoCode: promoCodeFormSelector(state, 'promoCode'),
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'PaymentHistory'),
		enableManualInstalment: franchisor.enableManualInstalment,
		canAddInstalment,
		isManualInstalment
	};
};

export default connect(mapStateToProps, {
	fetchPaymentHistory,
	updatePaymentHistory,
	markAsPaid,
	addInstalment,
	generateChildLessons,
	markAsCancelled,
	refundUnbookedAnnual,
	cancelLesson,
	sendInvoice,
	applyPromoCode,
	retryInstalment,
	markAsPaidInstalment,
	requestSubscriptionCancellation,
	withdrawSubscriptionCancellation
})(withTranslation()(Details));